import React from 'react'

const AddTrip = () => {
  return (
    <div>AddTrip</div>
  )
}

export default AddTrip